<template>
  <v-card
    class="mx-auto info-card"
    flat
  >
    <v-toolbar short flat>
      <v-toolbar-title>
        <v-icon>mdi-chart-arc</v-icon>
        {{ lang.historic.stats.title }}
      </v-toolbar-title>
    </v-toolbar>
    <div class="info-card-content">
      <Filters />
      <Chart customData />
      <Results customData />
    </div>
  </v-card>
</template>

<script>
import Filters from './info/Filters'
import Chart from './info/Chart'
import Results from './info/Results'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Filters, Chart, Results },
  mixins: [ appdata, utils ]
}
</script>
